import React from "react";
import ForNoVideoFound from "../ForNoVideoFound";

export default function PLaylistComponent() {
  return (
    <div>
      <ForNoVideoFound />
    </div>
  );
}
